module.exports = __webpack_public_path__ + "img/member_coupon_right.d182178c.png";